import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Switch,
  Modal,
  Input,
  Form,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { FaSliders } from "react-icons/fa6";
import IMAGES from "../../../const/Image";
import { components, getRowClassName } from "../../../utils/utils";
import userRequest from "../UserRequest";
import { UserFilters } from "./UserFilters";

const { confirm } = Modal;

const initialFilter = {
  page: 1,
};

export const Users = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [roleDetails, setRoleDetails] = useState();
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  // Fetch filtered users list
  const fetchUserFilterList = () => {
    setLoading(true);
    userRequest
      .userFilteredList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setFilteredUsers(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch users.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUserFilterList();
  }, [filter]);

  // Handle search filter
  const handleFilter = () => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    setIsModalOpen(false);
  };

  // Handle pagination changes
  const handleChange = (pagination) => {
    setFilter({ ...filter, page: pagination?.current });
  };

  // Reset filters to initial state
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  // Columns configuration for the Table
  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "UserName",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
    },
    // {
    //   title: "Wallet Amount",
    //   dataIndex: "walletAmt",
    //   key: "walletAmt",
    // },
    // {
    //   title: "Role",
    //   dataIndex: "roleName",
    //   key: "roleName",
    //   render: (role) => role,
    // },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 120,
      align: "center",
      render: (isActive, item) => (
        <Switch
          checked={isActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() =>
                navigate(`/user-management/users/update/${record.id}`)
              }
            >
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Handle status change (active/inactive)
  const handleStatusChange = (checked, item) => {
    if (!item.id) {
      notification.error({
        message: "User ID is required to update status.",
      });
      return;
    }
    // Uncomment and implement status change functionality if needed
    // confirm({
    //   title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this user?`,
    //   okText: "Yes",
    //   cancelText: "No",
    //   onOk() {
    //     setLoading(true);
    //     userRequest.updateUserStatus({
    //       status: checked ? 1 : 0,
    //       userId: item.id,
    //     })
    //       .then((res) => {
    //         if (res && res.status === 200) {
    //           notification.success({
    //             message: "User updated successfully",
    //           });
    //           fetchUserFilterList();
    //         } else {
    //           notification.error({
    //             message: "Failed to update status",
    //           });
    //         }
    //       })
    //       .catch(() => {
    //         notification.error({
    //           message: "Failed to update status",
    //         });
    //       })
    //       .finally(() => {
    //         setLoading(false);
    //       });
    //   },
    // });
  };

  return (
    <>
      <div>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Users List</h1>
          </Col>
          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              {/* <Button
                onClick={() => setIsModalOpen(true)}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button>
              <Button
                onClick={resetFilters}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                Reset
              </Button> */}
              {/* <Button
                onClick={() => navigate("/user-management/user/add")}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button> */}
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredUsers}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>
      <UserFilters
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};
